import { lazy, Suspense } from 'react';
import { Spin } from 'antd';

const ImagingViewer = lazy(() => import('../components/ImagingViewer'));

const ImagingViewerPage: React.FC = () => (
  <Suspense
    fallback={
      <div style={{ padding: 50, textAlign: 'center' }}>
        <Spin size="large" tip="Cargando visor..." />
      </div>
    }
  >
    <ImagingViewer />
  </Suspense>
);

export default ImagingViewerPage;
